<template>
  <div v-if="showAlgorithmSelect" class="mb-3">
    <span class="caption">Geogrid algorithm</span>
    <RadioPanels
      class="mb-3"
      name="algorithm"
      :value="algorithm"
      :values="values"
      @input="$emit('updateAlgorithm', $event)" />
    <div v-if="algorithm === 'newest'">
      <CustomInput
        :key="workersKey"
        label="Amount of parallel workers"
        name="parallel_workers"
        type="number"
        :value="parallelWorkers"
        @input="handleParallelWorkersInput" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RadioPanels from '../../components/radio_panels'
import CustomInput from '../../components/custom_input'

export default {
  components: {
    RadioPanels,
    CustomInput
  },
  props: {
    algorithm: {
      type: [String, Number],
      required: true
    },
    parallelWorkers: {
      type: Number,
      required: false,
      default: 1
    }
  },
  created() {
    this.values = [
      {
        text: 'Classic',
        value: 'classic'
      },
      {
        text: 'New',
        value: 'newest'
      }
    ]
  },
  computed: mapState([
    'showAlgorithmSelect'
  ]),
  data() {
    return {
      workersKey: 0,
      workersTimeout: null
    }
  },
  methods: {
    handleParallelWorkersInput(event) {
      clearTimeout(this.workersTimeout)

      this.workersTimeout = setTimeout(() => {
        let validated = event
        if (!validated || validated < 0) {
          validated = 1
          this.workersKey++
        } else if (validated > 50) {
          validated = 50
          this.workersKey++
        }

        this.$emit('updateParallelWorkers', validated)
      }, 1000)
    }
  }

}
</script>
